import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IEmailAutoTrigger } from "../emailAutoTriggerModel";

export const getAllEmailAutoTriggers = createAsyncThunk(
  "EmailAutomationTrigger/FindAllEmailAutomationTrigger",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmailAutomationTrigger/FindAllEmailAutomationTrigger`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Email Auto Triggers:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createEmailAutoTrigger = createAsyncThunk(
  "EmailAutomationTrigger/InsertEmailAutomationTrigger",
  async (EmailAutoTriggerData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmailAutomationTrigger/InsertEmailAutomationTrigger`,
        EmailAutoTriggerData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating email auto trigger:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateEmailAutoTrigger = createAsyncThunk(
  "EmailAutomationTrigger/UpdateEmailAutomationTrigger",
  async (EmailAutoTriggerData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmailAutomationTrigger/UpdateEmailAutomationTrigger`,
        EmailAutoTriggerData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating email auto trigger :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteEmailAutoTrigger = createAsyncThunk(
  "EmailAutomationTrigger/DeleteEmailAutomationTrigger",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmailAutomationTrigger/DeleteEmailAutomationTrigger`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting email auto trigger :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getEmailAutoTriggerByID = createAsyncThunk(
  "EmailAutomationTrigger/FindByIDEmailAutomationTrigger",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmailAutomationTrigger/FindByIDEmailAutomationTrigger`,
        { ID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        TriggerName: result?.TriggerName,
        Module: result?.Module,
        Operation: result?.Operation,
        Email_To: result?.Email_To,
        DelayDay: result?.DelayDay,
        DelayHour: result?.DelayHour,
        DelayTime: result?.DelayTime,
        SubjectName: result?.SubjectName,
        EmailText: result?.EmailText,
      } as IEmailAutoTrigger;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching email auto trigger :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const duplicateEmailAutoTrigger = createAsyncThunk(
  "EmailAutomationTrigger/DuplicateEmailAutomationTrigger",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmailAutomationTrigger/DuplicateEmailAutomationTrigger`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error duplicating email auto trigger :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
